import { useEmbarcacaoContatos } from "../../../../hooks/use-embarcacao-contatos";
import { EMPTY_FIELD_PLACEHOLDER, latestAtualizacao } from "../../../detail-format/detail-format";
import { buildDetailFields } from "../../../detail-format/detail-fields";
import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import {
  CONTATOS_EMPTY_STATE,
  CONTATOS_FIELDS,
  CONTATOS_ID,
  CONTATOS_LOADING_MESSAGE,
  CONTATOS_TEST_ID,
  CONTATOS_TITLE,
} from "./contatos-section.constants";
import { buildMailtoHref } from "./contatos-section.utils";

/** Campos de e-mail da embarcação: só eles viram link. */
const EMAIL_KEYS = new Set(CONTATOS_FIELDS.filter(({ email }) => email).map(({ key }) => key));

/** Seção Contatos do detalhamento da embarcação: somente leitura, com os campos já formatados para a View. */
export function useContatosSection({
  embarcacaoId,
  onReauthenticate,
}: EmbarcacaoDetailSectionProps) {
  const { status, contatos, errorMessage, reload } = useEmbarcacaoContatos(embarcacaoId);

  return {
    id: CONTATOS_ID,
    title: CONTATOS_TITLE,
    testId: CONTATOS_TEST_ID,
    fieldsTestId: `${CONTATOS_TEST_ID}-fields`,
    status,
    errorMessage,
    loadingMessage: CONTATOS_LOADING_MESSAGE,
    emptyContent: CONTATOS_EMPTY_STATE,
    onReauthenticate,
    onRetry: reload,
    // Só há data de atualização a exibir quando a seção tem dados.
    ultimaAtualizacao: contatos
      ? latestAtualizacao([contatos.ultimaAtualizacao, contatos.atualizacaoContato])
      : undefined,
    fields: buildDetailFields(
      contatos,
      CONTATOS_FIELDS,
      CONTATOS_TEST_ID,
      EMPTY_FIELD_PLACEHOLDER,
    ).map((field) => {
      const email = EMAIL_KEYS.has(field.key) ? contatos?.[field.key] : null;

      return { ...field, href: email ? buildMailtoHref(email) : undefined };
    }),
  };
}
